//import firebase from 'firebase'
import { initializeApp } from "firebase/app";
import { getAuth, signInAnonymously } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getMessaging, getToken } from "firebase/messaging";


const config = {
  apiKey: "AIzaSyAWPzue15u4PZlzwyEcWwWhnumt84lQPtA",
  authDomain: "inventory-308102.firebaseapp.com",
  projectId: "inventory-308102",
  databaseURL: "https://inventory-308102-default-rtdb.firebaseio.com",
  messagingSenderId: "79789578776",
  appId: "1:79789578776:web:c4c9fb80b3e80ac6ee816d"
}

const App = initializeApp(config);
export const DB = getFirestore(App)
export const firebaseAuth = getAuth(App);
export const messaging = getMessaging(App);


export async function anonSignIn() {
  await signInAnonymously(firebaseAuth)
  var user = firebaseAuth.currentUser
  if (user == null){
    console.log("Authenticated User not found")
    return (null)
  }
  else {
    let authToken = await user.getIdToken()
    return (authToken)
  }
}

async function getRegStatus(){
  if ('serviceWorker' in navigator) {
    const reg = await navigator.serviceWorker.register('firebase-messaging-sw.js')
    if (reg.active)
      return true
    else 
      return false
  } else {
      // happens when the app isn't served over HTTPS or if the browser doesn't support service workers
      console.warn('Service Worker not available');
      return false
    }
}

export async function getNotificationToken() {
  const permission = await Notification.requestPermission()

  if (permission == 'granted') {
    const regStatus = await getRegStatus()

    if (regStatus) {
      const token = await getToken(messaging, 
              { vapidKey: 'BJQ4_6tTBekShmnpiZkrDTxbB9BXLBnCLaeEnfTn0iZ1sUUI0d2yZZ877Vl7mO9z-BMJBCi_t4F79AdHaWNsugk' })
      return (token)
    }
    else {
      console.log("FCM SW not Active.")
      return ('')
    }

  } else {
    console.log('Notification permission not granted.')
    return ('')
  }
}

